<template>
    <div id="proximamente">
        <div class="container">
            <img class="logo" src="@/assets/isologotipo_chatpts_transparente.svg" alt="Logo de ChatPTS">
            <h1>¡En proceso de actualización!</h1>
            <p style="text-align: center;">
                Te pedimos disculpas. ¡Estamos terminando de subir una nueva y mejorada versión de ChatPTS!
            </p>
            <p class="no-highlight" style="text-align: center;">
                En pocas horas podrás disfrutar de todas las novedades.
            </p>
            <p class="no-highlight">Si tenés dudas, <a target="_blank"
                    href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit">contactanos</a>
            </p>
        </div>
    </div>
</template>

<script>

export default {
    name: "ChatComponent",
    props: {
    },

    data() {
        return {
        };
    },
    watch: {

    },

    async mounted() {
    }
};
</script>

<style scoped>
#proximamente {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    /* background-color: #111; */
    background-image: url('@/assets/fondo-prd-4.webp');
    background-size: cover;
    background-repeat: no-repeat;
    background-blend-mode: overlay;
    background-position: center;
    z-index: 0;
    margin: auto;
}

.logo {
    width: 400px;
}

#proximamente::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    z-index: -1;
    /* Capa semi-transparente sobre la imagen */
}

#proximamente .container {
    width: 90%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 48px;
    border-radius: 24px;
    background-color: rgba(50, 50, 50, 0.85);
    color: #f0f0f0;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.6);
}

#proximamente h1 {
    font-weight: bold;
    text-align: center;
    margin: 36px 0;
    font-size: 28pt;
}

#proximamente h2 {
    font-weight: bold;
    margin-bottom: 24px;
    margin-top: 12px;
}

#proximamente p {
    margin-bottom: 24px;
    font-size: 20pt;
    background-color: #a1344e;
    padding: 24px 48px;
    border-radius: 12px;
}

#proximamente p.no-highlight {
    background-color: transparent;
    padding: 0;
    margin: 0;
}

.login-footer-2 {
    padding-top: 24px;
    padding-bottom: 24px;
    color: #f0f0f0;

}

.login-footer-2 nav>* {
    margin: 12px;
}

/* MOBILE */
@media screen and (max-width: 768px) {
    #proximamente .container {
        width: 90%;
        padding: 24px;
    }

    .logo {
        width: 85%;
    }

    #proximamente h1 {
        font-weight: bold;
        text-align: center;
        margin: 24px 0 36px 0;
        font-size: 20pt;
    }

    #proximamente p {
        font-size: 16pt;
        padding: 24px 12px;
        text-align: center;
    }
}
</style>